import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('hashtags');
export const SETS_URI_PREFIX = checkIsStoryBookPath('hashtags/sets');
const URI_PREFIX_SETTINGS = checkIsStoryBookPath('settings');

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const apiRoutes = (isTrends = false) => {
  const HASHTAG_VIEW_PREFIX = 'hashtags/hashtag';
  const TRENDS_PREFIX = 'trends';
  const SETTINGS_PREFIX = 'settings';
  const moduleName = window.location.pathname.split('/')?.[1];
  const isTrendModule = moduleName === 'trends' || isTrends;
  const GENERATE_URI = (PREFIX) =>
    isTrendModule ? `${TRENDS_PREFIX}/${PREFIX}` : PREFIX;
  return {
    downloadSheet: `${URI_PREFIX}/hashtag/report`,
    downloadDetailedReport: `reports/detailed/download`,
    downloadFastDetailedReport: `/reports/fast/download`,
    downloadGroupFastDetailedReport: `/reports/influencers/group/fast/download`,
    downloadReportVersion: `reports/versions/download`,

    // SETS
    addSet: `${SETS_URI_PREFIX}/store`,
    addWords: `${SETS_URI_PREFIX}/words/store`,
    addWordsCsv: `${SETS_URI_PREFIX}/words/upload-csv-file`,
    getSetWithWords: `${SETS_URI_PREFIX}/show-with-words`,
    updateSet: `${SETS_URI_PREFIX}/update`,
    sets: `${SETS_URI_PREFIX}/all`,
    showSets: `${SETS_URI_PREFIX}/show`,

    activeSetsWord: `${SETS_URI_PREFIX}/words/active/all`,
    trashedSetsWord: `${SETS_URI_PREFIX}/words/trashed/all`,
    trashedSetsTable: `${SETS_URI_PREFIX}/trashed`,
    assignedHashtags: `${SETS_URI_PREFIX}/usages-hashtags`,
    assignedInfluencers: `${SETS_URI_PREFIX}/usages-influencers`,
    assignedEntities: `${SETS_URI_PREFIX}/usages-entities`,
    setsWords: `${SETS_URI_PREFIX}/words`,
    setsWordCount: `${SETS_URI_PREFIX}/count-words`,
    setsCount: `${SETS_URI_PREFIX}/count`,
    setsTrashedCount: `${SETS_URI_PREFIX}/trash/count`,
    deleteWord: `${SETS_URI_PREFIX}/trash-word`,
    trashSet: `${SETS_URI_PREFIX}/trash`,
    restoreSet: `${SETS_URI_PREFIX}/restore`,
    restoreWord: `${SETS_URI_PREFIX}/words/restore`,
    deleteSet: `${SETS_URI_PREFIX}/delete`,
    trashWord: `${SETS_URI_PREFIX}/words/trash`,
    deleteWord: `${SETS_URI_PREFIX}/words/delete`,
    hashtagCount: `${SETS_URI_PREFIX}/count-hashtag`,
    setsUsages: `${SETS_URI_PREFIX}/usages/all`,
    setsAutocomplete: `${SETS_URI_PREFIX}`,
    trashedSetsAutocomplete: `${SETS_URI_PREFIX}/trashed`,
    wordsAutocomplete: `${SETS_URI_PREFIX}/words`,
    influencersCount: `${SETS_URI_PREFIX}/count-influencers`,
    entitiesCount: `${SETS_URI_PREFIX}/count-entities`,
    tweetsCount: `${SETS_URI_PREFIX}/count-tweets`,
    instagramPostsCount: `${SETS_URI_PREFIX}/count-instagram-posts`,
    tiktokPostsCount: `${SETS_URI_PREFIX}/count-tiktok-posts`,
    youtubePostsCount: `${SETS_URI_PREFIX}/count-youtube-posts`,
    linkedinPostsCount: `${SETS_URI_PREFIX}/count-linkedin-posts`,
    assignTweets: `${SETS_URI_PREFIX}/usages-tweets`,
    assignInstagram: `${SETS_URI_PREFIX}/usages-instagram-posts`,
    assignTiktok: `${SETS_URI_PREFIX}/usages-tiktok-posts`,
    assignYoutube: `${SETS_URI_PREFIX}/usages-youtube-posts`,
    assignLinkedin: `${SETS_URI_PREFIX}/usages-linkedin-posts`,
    //Hashtag Table Tabs URL
    allHashtags: `${URI_PREFIX}/`,
    grabbedHashtags: `${URI_PREFIX}/grabbed`,
    allTrashed: `${URI_PREFIX}/all-trashed`,
    allUnAnalyzed: `${URI_PREFIX}/all-un-analyzed`,
    allUnUnnecessary: `${URI_PREFIX}/all-unnecessary`,
    allAnalyzed: `${URI_PREFIX}/all-analyzed`,
    allAnalyzed: `${URI_PREFIX}/all-analyzed`,
    allIncomplete: `${URI_PREFIX}/incomplete`,
    hashtagsLastGrabbedOn: `${GENERATE_URI(
      URI_PREFIX,
    )}/trending/last-grabbed-on`,

    //categories/Groups Hashtags
    influencerCategoriesHashtags: `influencers/categories/hashtags`,
    influencersGroupsHashtags: `influencers/groups/hashtags`,
    entitiesCategoriesHashtags: `entities/categories/hashtags`,
    entitiesGroupsHashtags: `entities/groups/hashtags`,

    // Hashtag Autocomplete URL
    HashtagAutoComplete: `${URI_PREFIX}`,
    AllHashtagAutoComplete: `${URI_PREFIX}`,
    grabbedHashtagAutoComplete: `${URI_PREFIX}/grabbed`,
    AnalyzedHashtagAutoComplete: `${URI_PREFIX}/analyzed`,
    UnanalyzedHashtagAutoComplete: `${URI_PREFIX}/unanalyzed`,
    TrendingHashtagAutoComplete: `${URI_PREFIX}/trending`,
    TrashedHashtagAutoComplete: `${URI_PREFIX}/trashed`,
    IncompleteHashtagAutoComplete: `${URI_PREFIX}/incomplete`,
    UnnecessaryHashtagAutoComplete: `${URI_PREFIX}/unnecessary`,
    allCountries: `${URI_PREFIX_SETTINGS}/countries/all`,

    //CRUD Hashtags
    restoreHashtag: `${GENERATE_URI(URI_PREFIX)}/restore`,
    trashHashtag: `${GENERATE_URI(URI_PREFIX)}/trash`,
    deleteHashtag: `${GENERATE_URI(URI_PREFIX)}/delete`,
    regrabHashtag: `${GENERATE_URI(URI_PREFIX)}/resync`,
    regrabHashtagPlatforms: `${GENERATE_URI(URI_PREFIX)}/platforms/resync`,
    resyncAllHashtags: `${GENERATE_URI(URI_PREFIX)}/trending/resync`,
    trashunccessaryHashtag: `${GENERATE_URI(URI_PREFIX)}/trash-or-unnecessary`,

    // HASHTAGS
    storeHashtag: `${GENERATE_URI(URI_PREFIX)}/store`,
    convertHashtagToKeyword: `${GENERATE_URI(URI_PREFIX)}/convert `,
    showHashtag: `${GENERATE_URI(URI_PREFIX)}/show-name`,
    resncHashtag: `${GENERATE_URI(URI_PREFIX)}/hashtag/regrab`,
    trendingListHashtags: `${GENERATE_URI(URI_PREFIX)}/hashtag/trending-dates`,
    updateHashtag: `${GENERATE_URI(URI_PREFIX)}/update`,
    addWordsPopup: `${GENERATE_URI(URI_PREFIX)}/words/add`,
    loadHashtagData: `${GENERATE_URI(URI_PREFIX)}/hashtag-data`,
    hashtagsCount: `${GENERATE_URI(URI_PREFIX)}/count`,
    relatedHashtags: `${GENERATE_URI(URI_PREFIX)}/hashtag/related/hashtags`,
    similarHashtags: `${GENERATE_URI(URI_PREFIX)}/hashtag/similar/hashtags`,
    analyzedHashtagsCount: `${GENERATE_URI(
      URI_PREFIX,
    )}/analyzed-hashtags-count`,
    trashedHashtagsCount: `${GENERATE_URI(URI_PREFIX)}/trashed-hashtags-count`,
    trendingHashtagsCount: `${GENERATE_URI(URI_PREFIX)}/trending/count`,
    unAnalyzedHashtagsCount: `${GENERATE_URI(
      URI_PREFIX,
    )}/un-analyzed-hashtags-count`,
    unNecessaryHashtagsCount: `${GENERATE_URI(
      URI_PREFIX,
    )}/unnecessary-hashtags-count`,
    bulkActions: `${GENERATE_URI(URI_PREFIX)}/change-status-hashtags`,
    bulkDelete: `${GENERATE_URI(URI_PREFIX)}/delete`,
    analyzeHashtag: `${GENERATE_URI(URI_PREFIX)}/sentiment-analysis`,
    hashtagTweets: `${GENERATE_URI(URI_PREFIX)}/tweets/all`,
    hashtagVideos: `${GENERATE_URI(URI_PREFIX)}/videos/all`,
    hashtagLinkedInPosts: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/all`,
    hashtagInstaPosts: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/all`,
    changeTweetType: `${GENERATE_URI(
      URI_PREFIX,
    )}/client-hashtag/change-tweets-category`,
    changeVideoType: `${GENERATE_URI(
      URI_PREFIX,
    )}/client-hashtag/change-videos-category`,
    changeLinkedInPostsType: `${GENERATE_URI(
      URI_PREFIX,
    )}/client-hashtag/change-linkedin-posts-category`,
    changeInstagramPostsType: `${GENERATE_URI(
      URI_PREFIX,
    )}/client-hashtag/change-instagram-posts-category`,
    changeTiktokPostsType: `${GENERATE_URI(
      URI_PREFIX,
    )}/client-hashtag/change-tiktok-posts-category`,
    topPostsTable: `${GENERATE_URI(URI_PREFIX)}/tweets/top-posts`,
    tweetRelatedHashtags: `${GENERATE_URI(URI_PREFIX)}/tweets/related-hashtags`,
    unnecessaryHashtagAction: `${GENERATE_URI(URI_PREFIX)}/unnecessary`,
    mostFrequentWords: `${GENERATE_URI(
      URI_PREFIX,
    )}/hashtag/unclassified/frequent-words`,
    mergeHashtagsAction: `${GENERATE_URI(URI_PREFIX)}/merge`,
    //shared apis trends & hashtags
    countriesMap: `${GENERATE_URI(URI_PREFIX)}/countries-map`,
    countriesMapByCoordinates: `${GENERATE_URI(
      URI_PREFIX,
    )}/trending/map/by-coordinates`,

    trendingHashtags: `${GENERATE_URI(URI_PREFIX)}/trending`,
    trendingHashtagsSec: `${GENERATE_URI(URI_PREFIX)}/secondary/trending`,
    trendingCompare: `${GENERATE_URI(URI_PREFIX)}/trending-compare`,
    trendingCompareTwentyFour: `${GENERATE_URI(
      URI_PREFIX,
    )}/trending-twenty-four`,
    hashtagsList: `${GENERATE_URI(URI_PREFIX)}/hashtags-list`,
    lastFiveTrendingHashtags: `${GENERATE_URI(
      URI_PREFIX,
    )}/bar-latest-five-hour`,
    mostMentionedHashtags: `${GENERATE_URI(URI_PREFIX)}/most-mentions`,
    mostMentionedHashtagsSec: `${GENERATE_URI(
      URI_PREFIX,
    )}/secondary/most-mentions`,

    unnecessaryHashtags: `${GENERATE_URI(URI_PREFIX)}/all-unnecessary`,
    longestMentionedHashtags: `${GENERATE_URI(URI_PREFIX)}/longest`,
    longestMentionedHashtagsSec: `${GENERATE_URI(
      URI_PREFIX,
    )}/secondary/longest`,

    hashtagView: `${GENERATE_URI(URI_PREFIX)}/hashtag/show`,
    hashtagTopLanguages: `${GENERATE_URI(HASHTAG_VIEW_PREFIX)}/top-languages`,
    hashtagTopCountries: `${GENERATE_URI(HASHTAG_VIEW_PREFIX)}/top-countries`,
    hashtagFrequentWords: `${GENERATE_URI(HASHTAG_VIEW_PREFIX)}/frequent-words`,
    hashtagFirstMention: `${GENERATE_URI(HASHTAG_VIEW_PREFIX)}/first-mention`,
    hashtagRealatedHashtages: `${GENERATE_URI(
      HASHTAG_VIEW_PREFIX,
    )}/related-hashtags`,

    hashtagGrabbingStatus: `${GENERATE_URI(
      URI_PREFIX,
    )}/hashtag/grabbing-status`,
    mentionsChart: `${GENERATE_URI(URI_PREFIX)}/show-mentions`,
    mentionsTopicsChart: `${GENERATE_URI(URI_PREFIX)}/mentions-topic`,
    compareHashtags: `${GENERATE_URI(URI_PREFIX)}/compare`,
    compareHashtagsTotalPosts: `${GENERATE_URI(URI_PREFIX)}/compare/posts/count`,
    topInfluencer: `${GENERATE_URI(URI_PREFIX)}/users`,
    showTweet: `${GENERATE_URI(URI_PREFIX)}/tweets/show`,
    topMentionInfluencer: `${GENERATE_URI(
      URI_PREFIX,
    )}/hashtag/influencers/top-mentioned`,
    topMentionedImage: `${GENERATE_URI(URI_PREFIX)}/hashtag/top-images`,
    topMentionedLinks: `${GENERATE_URI(URI_PREFIX)}/hashtag/top-links`,
    mostValuedTweets: `${GENERATE_URI(URI_PREFIX)}/hashtag/most-valued`,
    mostRetweetTweets: `${GENERATE_URI(URI_PREFIX)}/hashtag/most-retweet`,
    mostFavoritedTweets: `${GENERATE_URI(URI_PREFIX)}/hashtag/most-favourite`,
    typeOfTweetsMedia: `${GENERATE_URI(URI_PREFIX)}/hashtag/attachments/count`,
    influencersEntitiesCount: `${GENERATE_URI(
      URI_PREFIX,
    )}/hashtag/influencers/count`,
    potenialReach: `${GENERATE_URI(URI_PREFIX)}/hashtag/reach`,
    tweetsClassification: `${GENERATE_URI(
      URI_PREFIX,
    )}/hashtag/tweets/classification`,
    clientSources: `${GENERATE_URI(URI_PREFIX)}/hashtag/client-sources`,
    resyncRelatedHashtags: `${GENERATE_URI(URI_PREFIX)}/hashtag/related/hashtags/resync
`,

    //top posts
    titleAutoComplete: `${GENERATE_URI(URI_PREFIX)}/tweets`,
    influencerAutoComplete: `/influencers/details/influencers`,
    sentimentAnalysis: `${GENERATE_URI(URI_PREFIX)}/compare/sentiment-analysis`,
    logs: `${GENERATE_URI(URI_PREFIX)}`,

    // instagram tab
    instagramTotalPosts: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/count`,
    instagramSentimentPosts: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/sentiment-analysis`,
    instagramTopLanguage: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/languages/count`,
    instagramTopInfluencer: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/top-influencers`,
    instagramMostFavourite: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/most-favourite`,
    instagramFirstMention: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/first-mention`,
    instagramInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/influencers/count`,
    instagramEngagement: `${GENERATE_URI(URI_PREFIX)}/instagram/posts/engagement/count `,
    instagramSorting: `${SETTINGS_PREFIX}/instagram/posts/sorting`,

    // linkedin tab
    linkedinTotalPosts: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/count`,
    linkedinSentimentPosts: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/sentiment-analysis`,
    linkedinTopLanguage: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/languages/count`,
    linkedinTopInfluencer: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/top-influencers`,
    linkedinMostFavourite: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/most-engagement`,
    linkedinFirstMention: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/first-mention`,
    linkedinInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/influencers/count`,
    linkedinEngagement: `${GENERATE_URI(URI_PREFIX)}/linkedin/posts/engagement/count `,
    linkedinSorting: `${SETTINGS_PREFIX}/linkedin/posts/sorting`,

    // youtube tab
    videosTotalPosts: `${GENERATE_URI(URI_PREFIX)}/videos/count`,
    videosSentiment: `${GENERATE_URI(URI_PREFIX)}/videos/sentiment-analysis`,
    videosTopLanguage: `${GENERATE_URI(URI_PREFIX)}/videos/languages/count`,
    videosTopInfluencer: `${GENERATE_URI(URI_PREFIX)}/videos/top-influencers`,
    videosMostFavourite: `${GENERATE_URI(URI_PREFIX)}/videos/most-favourite`,
    videosMostViewed: `${GENERATE_URI(URI_PREFIX)}/videos/most-viewed`,
    videosFirstMention: `${GENERATE_URI(URI_PREFIX)}/videos/first-mention`,
    videosInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/videos/influencers/count`,
    videosEngagement: `${GENERATE_URI(URI_PREFIX)}/videos/engagement/count `,
    videosSorting: `${SETTINGS_PREFIX}/youtube/videos/sorting`,

    // twitter tab
    twitterTotalTweets: `${GENERATE_URI(URI_PREFIX)}/tweets/count`,
    twitterSentiment: `${GENERATE_URI(URI_PREFIX)}/tweets/sentiment-analysis`,
    twitterTopLanguage: `${GENERATE_URI(URI_PREFIX)}/tweets/top-languages`,
    twitterTopInfluencer: `${GENERATE_URI(URI_PREFIX)}/tweets/top-influencers`,
    twitterMostFavourite: `${GENERATE_URI(URI_PREFIX)}/tweets/most-favourite`,
    twitterMostViewed: `${GENERATE_URI(URI_PREFIX)}/tweets/most-viewed`,
    twitterFirstMention: `${GENERATE_URI(URI_PREFIX)}/tweets/first-mention`,
    twitterTopCountries: `${GENERATE_URI(URI_PREFIX)}/tweets/top-countries`,
    twitterMostValuedTweets: `${GENERATE_URI(URI_PREFIX)}/tweets/most-valued`,
    twitterMostRetweetTweets: `${GENERATE_URI(URI_PREFIX)}/tweets/most-retweet`,
    twitterMentionsChart: `${GENERATE_URI(URI_PREFIX)}/tweets/show-mentions`,
    twitterInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/tweets/influencers/count`,
    twitterClientSource: `${GENERATE_URI(URI_PREFIX)}/tweets/client-sources`,
    twitterClassification: `${GENERATE_URI(URI_PREFIX)}/tweets/classifications`,
    twitterTopMentionedLinks: `${GENERATE_URI(URI_PREFIX)}/hashtag/top-links`,
    twitterEngagement: `${GENERATE_URI(URI_PREFIX)}/tweets/engagement/count `,
    twitterSorting: `${SETTINGS_PREFIX}/twitter/tweets/sorting`,

    //summary tab
    summaryTotalPosts: `${GENERATE_URI(URI_PREFIX)}/hashtag/posts/count`,
    summarySentiment: `${GENERATE_URI(URI_PREFIX)}/hashtag/posts/sentiment-analysis`,
    summaryTopLanguage: `${GENERATE_URI(URI_PREFIX)}/hashtag/posts/languages/count`,
    summaryPostsType: `${GENERATE_URI(URI_PREFIX)}/hashtag/posts/types`,
    summaryMostFrequentWords: `${GENERATE_URI(URI_PREFIX)}/hashtag/frequent-words`,
    summaryRelatedHashtags: `${GENERATE_URI(URI_PREFIX)}/hashtag/related-hashtags`,
    summaryInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/hashtag/influencers/count`,
    summaryEngagement: `${GENERATE_URI(URI_PREFIX)}/hashtag/engagement/count`,
    // Tiktok tab
    tiktokTotalPosts: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/count`,
    tiktokSentiment: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/sentiment-analysis`,
    tiktokTopLanguage: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/languages/count`,
    tiktokTopInfluencer: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/top-influencers`,
    tiktokMostFavorite: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/most-favourite`,
    tiktokMostViewed: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/most-viewed`,
    tiktokFirstMention: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/first-mention`,
    tiktokInfluencersEntities: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/influencers/count`,
    tiktokEngagement: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/engagement/count `,
    tiktokSorting: `${SETTINGS_PREFIX}/tiktok/posts/sorting`,
    hashtagTiktokPosts: `${GENERATE_URI(URI_PREFIX)}/tiktok/posts/all`,
  };
};
